import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { setCurrentStep } from '../../redux/Slices/InterviewSlice';
import { setPlansPopUpOpen } from '../../redux/Slices/PaymentsSlice';
import { useAppSelector } from '../../redux/store/hooks';
import { setItem } from '../../utils/storage';
import Button from '../Common/Button';
import CommonDialog from '../Common/Dialog';

const UpgradePlanPopUP = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { upgradeDialogOpen, popUpPlanMessage } = useAppSelector(
    state => state.root.payments
  );

  const DialogContent = () => {
    return (
      <div className='flex flex-col items-center justify-center space-y-4 p-6 text-center'>
        <p className='text-lg font-medium text-gray-800'>
          Please upgrade your plan to continue.
        </p>
        <p className='text-sm text-gray-500'>{popUpPlanMessage}</p>
        <Button
          handleClickBtn={() => {
            dispatch(setPlansPopUpOpen(false));
            dispatch(setCurrentStep('start'));
            setItem({ key: 'activeItem', value: 'Payments' });
            navigate('/payments');
          }}
          label='Explore Plans'
          variant='contained'
        />
      </div>
    );
  };
  return (
    <CommonDialog
      isOpen={upgradeDialogOpen}
      close={() => dispatch(setPlansPopUpOpen(false))}
    >
      <DialogContent />
    </CommonDialog>
  );
};

export default UpgradePlanPopUP;
